import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVocalMicrophone: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vocal-microphone, singing, karaoke"><path fillRule="evenodd" clipRule="evenodd" d="M16.375 12C18.7912 12 20.75 10.0412 20.75 7.625C20.75 5.20875 18.7912 3.25 16.375 3.25C13.9588 3.25 12 5.20875 12 7.625C12 7.79966 12.0102 7.97193 12.0301 8.14125L15.8588 11.9699C16.0281 11.9898 16.2003 12 16.375 12Z" stroke="currentColor" strokeWidth="1.38158"/><path d="M12 8L3.25 17.625L6.375 20.75L16 12" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconVocalMicrophone;
